import React from 'react';
import { flexRender } from '@tanstack/react-table';
import { Rows } from '@teetsh/app/src/containers/Livrets/LivretEval/LivretEleve/components/LivretEleve/LivretTable/Rows';
import { css } from '@emotion/react';
import tw from 'twin.macro';
import { CenterRotatedCell } from 'components/CenterRotatedCell';

function getRowSpan(depth: number, nbOfSubHeaders: number, hasParent: boolean) {
  if (depth === 0) {
    if (nbOfSubHeaders === 1) {
      return 2;
    }
    return 1;
  }
  if (hasParent) {
    return 1;
  }
  return 0;
}

// Here is how the table is supposed to work
// It's a table that can be grouped by the first n columns
// It must be used with grouping state
// It will group the first column then the second ...
// the n-1 first column will be rotated if the n column is not empty

export function NewTable(props: any) {
  const { tableInstance } = props;
  return (
    <div className="p-2">
      <table>
        <thead>
          <tr style={{ visibility: 'collapse' }}>
            {tableInstance.getAllLeafColumns().map(column => {
              const size = column.columnDef.meta?.size || '1';
              return <th key={column.id} style={{ width: size }} />;
            })}
          </tr>
          {tableInstance.getHeaderGroups().map((headerGroup, index) => (
            <tr
              css={css`
                > th {
                  ${tw`sticky top-0 z-10 bg-neutral-white`}
                  ${index === 0 && tw`top-0`}
                  ${index === 1 && tw`top-10 z-10`}
                }
              `}
              tw="border-t"
              key={headerGroup.id}
            >
              {headerGroup.headers.map(header => {
                if (header.column.columnDef?.meta?.hide) {
                  return null;
                }
                const rowSpan = getRowSpan(
                  headerGroup.depth,
                  header.subHeaders.length,
                  header.column.parent !== undefined,
                );
                if (rowSpan === 0) {
                  return null;
                }
                const h = rowSpan === 2 ? header.subHeaders[0] : header;
                const isRotated = h?.column?.columnDef?.meta?.rotated;
                return (
                  <th
                    key={h.id}
                    colSpan={
                      h?.column?.columnDef?.meta?.colSpan || header.colSpan
                    }
                    rowSpan={rowSpan}
                    tw="text-center align-middle py-3 text-xs font-medium text-neutral-quiet uppercase tracking-tight border-r border-l"
                    css={[isRotated && tw`h-44 whitespace-nowrap`]}
                  >
                    <CenterRotatedCell active={isRotated}>
                      {h.isPlaceholder
                        ? null
                        : flexRender(h.column.columnDef.header, h.getContext())}
                    </CenterRotatedCell>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          <Rows
            groups={tableInstance.getState().grouping || []}
            rows={tableInstance.getGroupedRowModel().rows}
          />
        </tbody>
      </table>
      <div className="h-4" />
    </div>
  );
}
